@if(!isPlaceRoute) {
	<div class="flex flex-col fixed w-full z-50">
		@if (showTwitchBanner) {
			<peps-headband-twitch
				[link]='currentEventCalendar!.streamUrl ? currentEventCalendar!.streamUrl : "https://www.twitch.tv/fefegg"'
				(closeHeadband)="closeTwitchBanner()"

			></peps-headband-twitch>
		}
		<peps-navbar></peps-navbar>
	</div>
}
<peps-seasonal-snow></peps-seasonal-snow>
<router-outlet></router-outlet>
@if (loading.visible()) {
	<peps-loader [zIndex]="100"></peps-loader>
}
<peps-toast-container></peps-toast-container>

@if(!isPlaceRoute) {
	<peps-bell
		*featureFlag="'NOTIFICATION'"
	></peps-bell>
	<peps-footer></peps-footer>
	<peps-cookie-modal></peps-cookie-modal>
}
